;(function() {
  'use strict'

  angular.module('app.core').component('detailCard', {
    controller: Controller,
    templateUrl: 'detail-card.html',
    bindings: {
      item: '<',
      onClick: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    // ...
  }
})()
